// ExamineeStudentProgress 受検者進捗
import { Serializable } from '@/models/core/serializable';
import { SchoolClass } from '@/models/school-class/school-class';
import { GEnum } from '@/constants/enum.defination';
import { EvaluatorStudentProgress } from '@/models/evalSetting/examinee-student-progress';
import { Tag } from '@/models/tag';
import { store } from '@/store';

// 受検者進捗情報
export class ExamineeStudentProgress implements Serializable<ExamineeStudentProgress> {
  examineeStudentID: number;
  studentNumber: string; //学籍番号
  schoolClass: SchoolClass;
  lastName: string;
  firstName: string;
  status: GEnum.StatusProgress; // 全体のステータス
  iatEvalProgress: GEnum.IatOrSelfProgress; // 気質診断 進捗ステータス
  selfEvalProgress: GEnum.IatOrSelfProgress; // 自己評価 進捗ステータス
  giftEvalProgress: GEnum.GiftProgress; // 他者評価 進捗ステータス
  freeWordSkillProgress: GEnum.GiftProgress; // 強み評価 進捗ステータス
  trendProgress: GEnum.TrendProgress; // 傾向チェック 進捗ステータス
  evaluatorStudents: EvaluatorStudentProgress[]; // 評価者進捗
  completedAt: Date; // 完了日
  tags: Tag[];
  priorityTag: Tag;

  deserialize(input: any): ExamineeStudentProgress {
    this.examineeStudentID = input.examineeStudentID;
    this.studentNumber = input.studentNumber;
    this.schoolClass = new SchoolClass().deserialize(input.schoolClass);
    this.lastName = input.lastName;
    this.firstName = input.firstName;
    this.status = input.status;
    this.iatEvalProgress = input.iatEvalProgress;
    this.selfEvalProgress = input.selfEvalProgress;
    this.giftEvalProgress = input.giftEvalProgress;
    this.freeWordSkillProgress = input.freeWordSkillProgress;
    this.trendProgress = input.trendProgress;
    this.evaluatorStudents = input.evaluatorStudents.map((evaluatorStudent: EvaluatorStudentProgress) => new EvaluatorStudentProgress().deserialize(evaluatorStudent));
    this.completedAt = input.completedAt;
    this.tags = input.tags.map((t: Tag) => new Tag().deserialize(t));
    this.priorityTag = new Tag().deserialize(input.priorityTag);

    return this;
  }

  get fullName(): string {
    if (store.getters.isNameOrder) {
      // 日本語と同じ 姓 + 名
      return `${this.lastName} ${this.firstName}`;
    } else {
      // 日本語とは異なる 名 + 姓
      return `${this.firstName} ${this.lastName}`;
    }
  }

  get isStatusCompleted(): boolean {
    return this.status === GEnum.StatusProgress.Completed;
  }

  get isIatProgressCompleted(): boolean {
    return this.iatEvalProgress === GEnum.IatOrSelfProgress.Completed;
  }

  get isSelfProgressCompleted(): boolean {
    return this.selfEvalProgress === GEnum.IatOrSelfProgress.Completed;
  }

  get isGiftProgressCompleted(): boolean {
    return this.giftEvalProgress === GEnum.GiftProgress.Completed;
  }

  get isFreeWordSkillProgressCompleted(): boolean {
    return this.freeWordSkillProgress === GEnum.GiftProgress.Completed;
  }

  get isTrendProgressCompleted(): boolean {
    return this.trendProgress === GEnum.TrendProgress.Completed;
  }
}
